<template>
  <!--Main Container -->
  <div class="container justify-content-center mt-5">
    <h1>Customer Account Portal</h1>

    <!--Card Deck -->
    <div class="card-deck" role="list">
      <!--Subscription Card -->
      <info-card fa="id-card-o" :title="$t(LangConstants.my_subscription_title)" :text="$t(LangConstants.subscription_payment_helper_text)" bgvariant="blue" textvariant="dark" placeholder="placeholder">
        <div class="mt-5 mb-5 row info-card-custom-content">
          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">
                <!--{{ $t(customerSubscription.subscription.title) }}-->
                Sparkfore Educator
              </h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="font-weight-bold mr-2">
                Site:
                <a target="_blank" :href="this.$store.getters.instanceUrl">{{ this.$store.getters.instanceUrl }}</a>
              </div>
            </div>
          </div>
        </div>
      </info-card>
      <!--Ending Subscription Card -->

      <!--Users Card -->
      <info-card fa="users" :title="$t(LangConstants.participants_title)" :text="$t(LangConstants.participant_invoice_helper_text)" bgvariant="red" textvariant="dark" placeholder="placeholder">
        <div class="mt-5 mb-5 row info-card-custom-content">
          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getMonthlySubscribers }}</h3>
              <div class="ml-2 vertical-allign-super">
                <b-badge variant="success">
                  <i class="fa fa-arrow-up" aria-hidden="true"></i>
                </b-badge>
              </div>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.new_participants_per_month_text) }}</div>
            </div>
          </div>

          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllTimeUsers }}</h3>
              <div class="ml-2 vertical-allign-super">
                <b-badge variant="success">
                  <i class="fa fa-arrow-up" aria-hidden="true"></i>
                </b-badge>
              </div>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.participants_all_time_text) }}</div>
            </div>
          </div>
        </div>
      </info-card>
      <!--Ending Users Card -->

      <!--Licenses Card -->
      <info-card fa="rocket" :title="$t(LangConstants.portal_licenses_title)" :text="$t(LangConstants.portal_licenses_helper_text)" bgvariant="yellow" textvariant="dark" placeholder="placeholder">
        <div class="mt-5 mb-5 row info-card-custom-content">
          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllOwnLicenses }}</h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.last30days) }}</div>
            </div>
          </div>

          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllOwnLicenses }}</h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.last12months) }}</div>
            </div>
          </div>
        </div>
      </info-card>
      <!--Ending Licenses Card -->

      <!-- Courses Completion Card -->
      <info-card fa="trophy" :title="$t(LangConstants.portal_coursecompletions_title)" :text="$t(LangConstants.portal_coursecompletions_helper_text)" bgvariant="grey" textvariant="dark" placeholder="placeholder">
        <div class="mt-5 mb-5 row info-card-custom-content">
          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllOwnUsersCompletions }}</h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.last30days) }}</div>
            </div>
          </div>

          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllOwnUsersCompletions }}</h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.total_text) }}</div>
            </div>
          </div>
        </div>
      </info-card>
      <!--Ending Courses Completion Card -->

      <!-- Certificate Renewals Card -->
      <info-card fa="bell" :title="$t(LangConstants.portal_certificaterenewals_title)" :text="$t(LangConstants.portal_certificaterenewals_helper_text)" bgvariant="blue" textvariant="dark" placeholder="placeholder">
        <div class="mt-5 mb-5 row info-card-custom-content">
          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllOwnCertificates }}</h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.next3months) }}</div>
            </div>
          </div>

          <div class="col content-item">
            <div class="title">
              <h3 class="font-weight-bold">{{ getAllOwnCertificates }}</h3>
            </div>
            <div class="d-flex mt-4 content">
              <div class="text-muted">{{ $t(LangConstants.next12months) }}</div>
            </div>
          </div>
        </div>
      </info-card>
      <!--Ending Certificate Renewals Card -->
    </div>
    <!--Ending Card Deck -->
  </div>
  <!--Ending Main Container -->
</template>

<script>
import InfoCard from "../../components/organisms/InfoCard.vue";
//import CardLink from "../components/atoms/CardLink.vue";
//import "../../assets/scss/common.scss";
//import common from "../../functions/index";
import Constants from "../../constants/index";

export default {
  setup() {
    return {};
  },
  data() {
    return {};
  },

  methods: {},

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  components: {
    InfoCard,
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin: 15px;
  flex: 1 0 40%;
}
.info-card-body {
  .info-card-custom-content {
    .content-item {
      .title {
        * {
          display: inline;
        }
      }
    }
  }
}
.container {
  padding-bottom: 30px;
}
</style>
